import { IconText } from './IconText';

export type { TypeIconTextProps } from './types';
export default IconText;
